import React from 'react';
import { Link } from "react-router-dom";
import {userService} from "../../services";
import moment from 'moment-jalaali';

const menu = props => {

    

    return (
        <div className="navbar-default sidebar" role="navigation">
                <div className="sidebar-nav navbar-collapse">
                    <ul className="nav" id="side-menu">
                        <li class="sidebar-search">
                                <div class="masked">    
                                    {moment(userService.getLoginTime()).isValid() && moment(userService.getLoginTime()).format("dddd، jD jMMMM jYYYY")}<br></br>
                                    {moment(userService.getLoginTime()).isValid() && moment(userService.getLoginTime()).locale('en').format("dddd, D MMMM YYYY")}<br></br>
                                    {userService.getUserCity()!=null && userService.getUserCity().Title }
                                </div>
                           
                        </li>
                       
                        <li>
                            <Link to="/dashboard"><i className="fa fa-dashboard fa-fw"></i> داشبورد</Link>
                        </li>
                        <li>
                            <Link to="/patient"><i className="fa fa-user fa-fw"></i> پذیرش جدید</Link>
                        </li>
                        <li>
                            <Link to="/certrequestlist"><i className="fa fa-file fa-fw"></i>میز کار</Link> 
                        </li>
                        <li>
                            <Link to="/patients"><i className="fa fa-users fa-fw"></i>آرشیو</Link>
                        </li>

                        <li>
                            <Link to="/message/inbox"><i className="fa fa-envelope fa-fw"></i>پیام های دریافتی</Link>
                        </li>

                        <li>
                            <Link to="/message/outbox"><i className="fa fa-envelope fa-fw"></i>پیام های ارسالی</Link>
                        </li>

                        <li>
                            <Link to="/quickcertrequest"><i className="fa fa-users fa-fw"></i>پذیرش سریع</Link>
                        </li>
                      
                    </ul>
                </div>
                {/* <!-- /.sidebar-collapse --> */}
        </div>
    );
};

export default menu;


